import { Component, OnInit } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { EosListService } from './eos-list.service';
import { ActivatedRoute } from '@angular/router';
import { IEOSDataItem } from './entities/eos-data';

@Component({
  selector: 'app-eos-list',
  templateUrl: './eos-list.component.html',
  styleUrls: ['./eos-list.component.scss']
})
export class EosListComponent implements OnInit {

  viewEOSState$: Observable<any>;
  public totalNotEngaged: string;
  public totalRegularTime: string;
  public totalOvertime: string;
  public totalDoubleTime: string;
  public totalTime: string;

  constructor(private eosData: EosListService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.refreshEOSData();
  }

  showHeader() {
    var x = document.getElementById("pageheader");

    x.style.display = x.style.display === "none" ? "block" : "none";

    var t = document.getElementById("headTriger");
    t.style.top = x.style.display === "none" ? "10px" : "60px";

    var i = document.getElementById("headTrigerIcon");
    i.className = x.style.display === "none" ? "fa fa-arrow-down" : "fa fa-arrow-up";
  }

  refreshEOSData() {
    this.viewEOSState$ = timer(0, 2000 /* 2sec */).pipe(
      switchMap(() => this.eosData.getEOSData(this.route.snapshot.paramMap.get('market'))),
      tap(eos => {
        let n: number = (<Array<any>>eos.Items).reduce((v, cv) => v + (cv.DurationSeconds + cv.DurationNextJobSeconds), 0);
        this.totalNotEngaged = this.secondsToTime(n, 1);

        let t: number = (<Array<any>>eos.Items).reduce((v, cv) => v + (cv.PayClockTotal * 60), 0);
        this.totalTime = this.secondsToTime(t, 1);

        let r: number = (<Array<any>>eos.Items).reduce((v, cv) => v + (cv.PayClockRegular * 60), 0);
        this.totalRegularTime = this.secondsToTime(r, 1);

        let o: number = (<Array<any>>eos.Items).reduce((v, cv) => v + (cv.PayClockOvertime * 60), 0);
        this.totalOvertime = this.secondsToTime(o, 1);

        let d: number = (<Array<any>>eos.Items).reduce((v, cv) => v + (cv.PayClockOvertimeDouble * 60), 0);
        this.totalDoubleTime = this.secondsToTime(d, 1);
      })
    );
  }

  secondsToTime(sec: number, inclSec: number): string {

    var hours   = Math.floor(sec / 3600);
    var minutes = Math.floor((sec - (hours * 3600)) / 60);
    var seconds = sec - (hours * 3600) - (minutes * 60);

    //console.log('sec: ' + sec + ' hours: ' + hours + ' min: ' + minutes + ' seconds ' + seconds);

    return hours.toString().padStart(2, '0') + ':' +
      minutes.toString().padStart(2, '0') + 
      (inclSec === 1 ? ':' + seconds.toString().padStart(2, '0') : '');
  }

  getBarRegularWidth(item: IEOSDataItem): number {
    return item.PayClockTotal > 0 ? (item.PayClockRegular * 100) / item.PayClockTotal : 0;
  }

  getBarOvertimeWidth(item: IEOSDataItem): number {
    return item.PayClockTotal > 0 ? (item.PayClockOvertime * 100) / item.PayClockTotal : 0;
  }

  getBarDoubleTimeWidth(item: IEOSDataItem): number {
    return item.PayClockTotal > 0 ? (item.PayClockOvertimeDouble * 100) / item.PayClockTotal : 0;
  }
}
